import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { getValuesFromEnum } from "@app/class/Utilities";
import { IFileUploadDetails } from "@app/directives/_forms/fileUpload/fileUpload.component";
import { untilDestroyed } from "@ngneat/until-destroy";
import { take } from "rxjs/operators";
import { CameraApplicationState, CameraAppType, ICameraApp } from "../../_models/ICameraApp";
import { CameraAppService } from "../../_services/camera-app.service";
import './application-editor.component.scss';

@Component({
    selector: 'app-editor',
    template: require('./application-editor.component.html')
})
export class AppEditorComponent implements OnInit, OnChanges {
    @Input() app: ICameraApp;
    @Output() appSaved: EventEmitter<FormData> = new EventEmitter<FormData>();
    @Output() formUpdated: EventEmitter<void> = new EventEmitter<void>();
    //--

    appForm: FormGroup;

    appTypes = getValuesFromEnum(CameraAppType).filter(type => type !== CameraAppType.Firmware);
    CameraAppType = CameraAppType;

    applicationStates = getValuesFromEnum(CameraApplicationState);
    CameraApplicationState = CameraApplicationState;


    selectedType: CameraAppType;
    selectedState: CameraApplicationState;

    file: File;
    editMode: boolean;

    constructor(
        private readonly cameraAppService: CameraAppService) { }

    ngOnInit(): void {
        this.createForm();
    }

    ngOnChanges(): void {
        if (this.app.Id?.trim()) {
            this.editMode = true;
        }
    }

    onStateChanged(value: CameraApplicationState): void {
        this.selectedState = value;
        this.appForm.get("State").setValue(value);
        this.app.State = this.selectedState;
    }

    onTypeChanged(value: CameraAppType): void {
        this.selectedType = value;
        this.appForm.get("CameraAppType").setValue(value);
    }

    saveApp(): void {
        this.appForm.markAllAsTouched();

        if (!this.appForm.valid || !this.file) {
            return;
        }
        const formData = new FormData();

        formData.append('file', this.file);

        for (const key in this.app) {
            if (this.app.hasOwnProperty(key)) {
                formData.append(key, this.app[key]);
            }
        }

        this.appSaved.emit(formData);
    }

    addFile(file: IFileUploadDetails): void {
        this.file = file.file;
        this.appForm.get("File").setValue(this.file);
    }

    downloadFile(): void {
        this.getFile();
    }
    //--

    private createForm(): void {
        this.appForm = new FormGroup({
            CameraAppType: new FormControl(this.app.CameraAppType),
            Name: new FormControl(this.app.Name, [Validators.required]),
            Description: new FormControl(this.app.Description, [Validators.required]),
            State: new FormControl(this.app.State),
            Version: new FormControl(this.app.Version),
            File: new FormControl(this.file, [Validators.required])
        })

        this.selectedState = this.app.State;
        this.selectedType = this.app.CameraAppType;

        this.appForm.statusChanges.pipe(untilDestroyed(this)).subscribe((status: string) => {
            if (status == "INVALID") {
                return;
            }

            this.app = {
                ...this.app,
                CameraAppType: this.appForm.get("CameraAppType").value,
                Name: this.appForm.get("Name").value,
                Description: this.appForm.get("Description").value,
                State: this.appForm.get("State").value,
                Version: this.appForm.get("Version").value
            }

            this.file = this.appForm.get("File").value;

            this.formUpdated.emit();
        })
    }

    private getFile(): void {
        this.cameraAppService.downloadFile(this.app.Id).pipe(
            take(1)
        ).subscribe({
            next: file => {
                const url = window.URL.createObjectURL(file);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${this.app.Name}.apk`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }
        })
    }
}
